import { resolveAssetUrl } from './resolveAssetUrl';

function normalizeBannerType(type) {
  return String(type || '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '_');
}

/** Pick banner image URL from API image object (`thumbnail`, `medium`, `large`, `url`). */
export function bannerImageSrc(image, { size = 'large' } = {}) {
  if (!image) return '';
  if (typeof image === 'string') return resolveAssetUrl(image);

  const raw =
    size === 'thumb'
      ? image.thumbnail || image.url
      : size === 'medium'
        ? image.medium || image.large || image.url
        : image.large || image.url || image.medium;

  return resolveAssetUrl(raw);
}

export function pickBannerImageUrl(image) {
  return bannerImageSrc(image, { size: 'large' });
}

export function getBannerSlides(bannersRes, pageType, { size = 'large' } = {}) {
  const targetType =
    pageType === 'login'
      ? 'login_page'
      : pageType === 'landing'
        ? 'landing_page'
        : normalizeBannerType(pageType);

  const list = bannersRes?.data || bannersRes || [];
  const banner = (Array.isArray(list) ? list : []).find(
    (item) => normalizeBannerType(item?.banner_type) === targetType
  );

  const urls = (banner?.images?.map((img) => bannerImageSrc(img, { size })).filter(Boolean) || []).map(
    (url) => String(url)
  );

  return Array.from(new Set(urls));
}

const loadedBanners = new Set();

export function isBannerSlideLoaded(src) {
  return loadedBanners.has(src);
}

export function preloadBannerSlides(urls) {
  if (!Array.isArray(urls) || !urls.length) return Promise.resolve([]);

  const unique = [...new Set(urls.filter(Boolean))];

  return Promise.all(
    unique.map(
      (src) =>
        new Promise((resolve) => {
          if (loadedBanners.has(src)) {
            resolve(src);
            return;
          }

          const img = new Image();
          img.decoding = 'async';
          img.onload = () => {
            loadedBanners.add(src);
            resolve(src);
          };
          img.onerror = () => {
            loadedBanners.add(src);
            resolve(src);
          };
          img.src = src;
        })
    )
  );
}
